"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useUpdateDocumentAccess.default;
  }
});

var _useUpdateDocumentAccess = _interopRequireDefault(require("./useUpdateDocumentAccess"));

var _useUpdateDocumentAccess2 = require("./useUpdateDocumentAccess.types");

Object.keys(_useUpdateDocumentAccess2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUpdateDocumentAccess2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUpdateDocumentAccess2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VVcGRhdGVEb2N1bWVudEFjY2Vzcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlVXBkYXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VVcGRhdGVEb2N1bWVudEFjY2Vzcy50eXBlcyc7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useUpdateDocumentAccess/index.js
// module id = 1845
// module chunks = 0